import React, { Component } from 'react'
import moment from 'moment'
import { styles } from "../../../../../ReactConst"
import { StyleRoot } from 'radium';
import iconValider from '../../../../../styles/img/icon-check-white.svg';
import Img from 'react-image'
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import _ from 'lodash'
const IconValider = () => <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />

function Arrivee({ event, name }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic">
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateArrivee).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatRepas == "BEAUCOUP" ? "A bien déjeuné" : event.etatRepas == "CORRECTEMENT" ? "A correctement mangé" : "A peu mangé"}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatSommeil === "MAL" ? "A mal dormi" : "A bien dormi"}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatSante == 'A_SURVEILLER' ? "A surveiller" : event.etatSante == 'INQUIETANT' ? "Etat inquiétant" : "Rien à signaler"}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.sousTraitement ? "Sous traitement" : "Pas sous traitement"}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{"Repartira avec " + event.prenomParent ? event.prenomParent : event.prenomTierAutorise}</span>
        </label>
      </div>
    </div>
  )
}
function Depart({ event, name }) {
  return (
    <div class="col-md-4 mb-3">
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.timeDepart).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{"Récupéré avec " + event.prenomParent ? event.prenomParent : event.prenomTierAutorise}</span>
        </label>
      </div>
    </div>
  )
}
function Sieste({ event, name }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{'De ' + moment(event.offsetDateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{'A ' + moment(event.offsetDateTimeFin).format("HH[h]mm")}</span>
        </label>
      </div>
    </div>
  )
}
function Repas({ event, name }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        {event.aliments.map((aliment, index) =>
          event.quantite ?
            <label key={index} class="rounded15 box-shadow d-flex justify-content-center">
              <span class="name">{aliment.libelle + " " + event.quantite + "ml"}</span>
            </label>
            :
            <label key={index} class="rounded15 box-shadow d-flex justify-content-center">
              <span class="name">{aliment.libelle}</span>
            </label>
        )}
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatRepas && event.etatRepas === "PEU" ? "A peu mangé" : event.etatRepas === "CORRECTEMENT" ? "A correctement mangé" : 'A bien mangé'}
          </span>
        </label>
      </div>
    </div>
  )
}
function Activite({ event, name }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          {event.activiteType === "AUTRE" ? <span class="name">{event.libelle}</span> : <span class="name">{formatActivite(event.activiteType)}</span>}
        </label>
      </div>
    </div>
  )
}
function Incident({ event, name }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center" >
          <span class="name">{name}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          {event.typeIncident === "AUTRE" ? <span class="name">{event.remarque}</span> : <span class="name">{formatIncident(event.typeIncident)}</span>}
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.etatSante && event.etatSante === "RIEN_DE_GRAVE" ? "Rien de grave" : event.etatSante === "INQUIETANT" ? "Inquiétant" : 'A surveiller'}</span>
        </label>
      </div>
    </div>
  )
}
function PetitCoin({ event, name }) {
  return (
    <div class="col-md-4 mb-3" >
      <div class="bloc-contre-indic" >
        <p class="title mb-3">{name}</p>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{moment(event.dateTime).format("HH[h]mm")}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.support && event.support === "COUCHE" ? "Couche" : event.support === "POT" ? "Pot" : 'Cuvette'}</span>
        </label>
        <label class="rounded15 box-shadow d-flex justify-content-center">
          <span class="name">{event.aspect && event.aspect === "NORMAL" ? "Normal" : 'Anormal'}</span>
        </label>
      </div>
    </div>
  )
}

function formatActivite(string) {
  switch (string) {
    case "PATE_A_MODELER":
      return "Pâte à modeler"

    case "PEINTURE":
      return "Peinture"

    case "DANSE":
      return "Danse"

    case "PISCINE":
      return "Piscine"

    case "LECTURE":
      return "Lecture"

    case "SORTIE":
      return "Sortie"

    case "ACTIVITE_MANUELLE":
      return "Activité Manuelle"

    case "AUTRE":
      return "Autre"

    default:
      return ""

  }
}
function formatIncident(string) {
  switch (string) {
    case "FIEVRE":
      return "Fièvre"

    case "VOMI":
      return "Vomi"

    case "TOUX":
      return "Toux"

    case "BLESSURE":
      return "Blessure"

    case "BOUTONS":
      return "Boutons"

    default:
      return ""

  }
}

class ModalTransmission extends Component {
  constructor(props) {
    super(props)

    this.state = {
      styleFadeIn: true,
    }
    this.closeModal = this.closeModal.bind(this);
  }
  closeModal = () => {
    this.setState({
      styleFadeIn: false
    })
    setTimeout(() => {
      this.props.onCloseModaleTransmission()
    }, 400);
  }

  renderEvent(event) {
    let typeEvent = event.typeEvent;
    switch (typeEvent) {
      case "ARRIVEE":
        return <Arrivee event={event.event} name={"Arrivée"} />
      case "ACTIVITE":
      case "PATE_A_MODELER":
      case "PEINTURE":
      case "PEINTURE":
      case "DANSE":
      case "PEINTURE":
      case "SORTIE":
      case "PISCINE":
      case "LECTURE":
      case "ACTIVITE_MANUELLE":
      case "AUTRE":
        return <Activite event={event.event} name={"Activité"} />
      case "DEPART":
        return <Depart event={event.event} name={"Sortie"} />
      case "INCIDENT":
      case "FIEVRE":
      case "VOMI":
      case "TOUX":
      case "BLESSURE":
      case "BOUTONS":
      case "AUTRE":
        return <Incident event={event.event} name={"Incident"} />
      case "SIESTE":
        return <Sieste event={event.event} name={"Sieste"} />
      case "REPAS":
      case "BIBERON":
      case "REPAS_PEU":
      case "REPAS_CORRECTEMENT":
      case "REPAS_BEAUCOUP":
        return <Repas event={event.event} name={"Repas"} />
      case "PETITE_COMMISSION":
      case "GROSSE_COMMISSION":
        return <PetitCoin event={event.event} name={typeEvent === "PETITE_COMMISSION" ? "Pipi" : "Selles"} />
      default:
        return ""
    }
  }

  render() {
    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;
    const { eventsDetails, onCloseModaleTransmission, transmissionLoading } = this.props
    return (
      <StyleRoot>
        <div class="modal show fade modal-skin modal-large" id="modalTransmission" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" tabIndex="-1" role="dialog"
          style={this.state.styleFadeIn === true ? styles.bounce : styles.bounce2}
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <form>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <img src="img/close.svg" class="img-fluid" alt="" />
                </button>
                <div class="modal-body fiche-enfant">
                  <h2 class="modal-title mb-3">Transmission</h2>
                  <p class="bottom-space"></p>
                  <section class="content-section">
                    <DotLoader
                      size={100}
                      color={"#ff7d26"}
                      css={override}
                      loading={transmissionLoading && _.isEmpty(eventsDetails)}
                    />
                    <div class="row row-contre-indic align-items-stretch" >
                      {eventsDetails.map(event =>
                        this.renderEvent(event)
                      )}
                    </div>
                  </section>
                  <div class="d-flex justify-content-center">
                    <div class="row align-items-center">
                      <button onClick={this.closeModal} type="button" class="btn-gradient btn-valid margin-left" data-dismiss="modal"><IconValider /> OK</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    )
  }
}

export default ModalTransmission;